import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";

export default new (class {
  checkDisciplineCode(data) {
    return to(
      http.get(
        `availability/energy?longitude=${data.longitude}&latitude=${data.latitude}`
      )
    );
  }
  checkPostCode(data) {
    return to(
      http.get(
        `${urls.default.checkpostcode}?postcode=${data.postcode}&houseNumber=${data.housenumber}`
      )
    );
  }
  checkZiggo(data) {
    return to(
      http.get(
        `${urls.default.checkziggo}?postcode=${data.postcode}&houseNumber=${data.housenumber}&houseNumberAddition=${data.houseNumberAddition}`
      )
    );
  }
  checkYoufone(data) {
    return to(
      http.get(
        `${urls.default.checkyoufone}?postcode=${data.postcode}&houseNumber=${data.housenumber}&houseNumberAddition=${data.houseNumberAddition}`
      )
    );
  }

  checkKpn(data) {
    return to(
      http.get(
        `${urls.default.checkkpn}?postcode=${data.postcode}&houseNumber=${data.housenumber}&houseNumberAddition=${data.houseNumberAddition}`
      )
    );
  }
  checkTmobile(data) {
    return to(
      http.get(
        `${urls.default.checktmobile}?postcode=${data.postcode}&houseNumber=${data.housenumber}&houseNumberAddition=${data.houseNumberAddition}`
      )
    );
  }
  getClients(data) {
    return to(http.get(`${urls.default.clients}?pageSize=${data}`));
  }
  getCountryList(lang) {
    return to(
      http.get(`${urls.default.countries}`, {
        headers: {
          language: lang
        }
      })
    );
  }
  getTranslate() {
    return to(http.get(`${urls.translations.get}`));
  }
  getRates(data) {
    return to(
      http.get(
        `${urls.default.getrates}?propositions=${data.propositions}&product_id=${data.product_id}&meter_type=${data.meter_type}`
      )
    );
  }
  getConsumptionList() {
    return to(http.get(`${urls.default.getconsumptionlist}`));
  }
  getSolarList() {
    return to(http.get(`${urls.default.getsolarlist}`));
  }
  getMortgage(data) {
    return to(
      http.get(
        `${urls.mortgage.get}?first_income=${data.first}&second_income=${data.second}`
      )
    );
  }
  updateColumn(formdata) {
    return to(http.post(`${urls.editable.column}`, formdata));
  }

})();
